import { Observation } from "@medplum/fhirtypes";

import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCurrentLaborStage } from "@/encounters/components/EncounterLabor/services/labor";

import { RootState } from "..";

const laborStagesAdapter = createEntityAdapter({
  selectId: (component: Observation) => component.valueCodeableConcept?.coding?.[0].code ?? "",
});

const reducers = {
  loadLaborStages: laborStagesAdapter.setAll,
  addLaborStage: laborStagesAdapter.addOne,
  updateLaborStage: laborStagesAdapter.updateOne,
};

export const laborStagesSlice = createSlice({
  name: "laborStages",
  initialState: laborStagesAdapter.getInitialState(),
  reducers,
});

export const { loadLaborStages, addLaborStage, updateLaborStage } = laborStagesSlice.actions;

export const selectLaborStageEntities = (state: RootState) => state.laborStages.entities;

export const selectCurrentLaborStage = (state: RootState) => {
  const laborStages = Object.values(state.laborStages.entities);
  return getCurrentLaborStage(laborStages);
};

export default laborStagesSlice.reducer;
